import React from 'react';
import { AnimateOnScroll } from '../AnimateOnScroll';
import { CheckIcon } from 'lucide-react';
export function HLAddOns() {
  return <section className="bg-black py-[60px] lg:py-[100px]" data-id="element-1335">
      <div className="max-w-[1200px] mx-auto px-6 lg:px-8" data-id="element-1336">
        <AnimateOnScroll className="text-center flex flex-col items-center mb-12" data-id="element-1337">
          <h2 className="text-[28px] lg:text-[44px] uppercase text-white leading-tight mb-6 font-[600] font-[Poppins,_sans-serif]" data-id="element-1338">
            ADD ONS FOR MAXIMUM RESULTS
          </h2>
          <div className="w-[40px] h-[2px] bg-[#FF1493] mb-8" data-id="element-1339"></div>

          <p className="text-[#B0B0B0] italic text-base leading-[1.7] font-body max-w-[800px]" data-id="element-1340">
            Coming soon to Be CLINICAL is an incredible add-on to Halo Skin
            Resurfacing; "time zero" stem cells. This revolutionary stem cell
            technology is derived from full-term c-section umbilical cords. Stay
            tuned for more details soon!{' '}
            <span className="inline-block bg-[#FF1493] text-white text-xs font-bold px-3 py-1 rounded-full ml-2 not-italic tracking-wider" data-id="element-1341">
              COMING SOON
            </span>
          </p>
        </AnimateOnScroll>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-1342">
          <AnimateOnScroll data-id="element-1343">
            <div className="bg-[#111111] p-9 border-t-[3px] border-[#FF1493] h-full" data-id="element-1344">
              <h3 className="text-white text-[22px] font-bold font-[Poppins,_sans-serif] mb-4" data-id="element-1345">
                Exosomes
              </h3>
              <p className="text-[#B0B0B0] text-[15px] leading-[1.7] font-body" data-id="element-1346">
                Enhance your Halo Skin Resurfacing Laser treatment with exosomes
                for even better results. When applied immediately after your
                laser treatment, exosomes amplify healing and skin regeneration
                by delivering growth factors and proteins directly to your skin
                cells. This boosts cellular communication and collagen
                production, reducing inflammation and improving skin texture,
                tone, and overall health.
              </p>
            </div>
          </AnimateOnScroll>

          <AnimateOnScroll delay={150} data-id="element-1347">
            <div className="bg-[#111111] p-9 border-t-[3px] border-[#FF1493] h-full" data-id="element-1348">
              <h3 className="text-white text-[22px] font-bold font-[Poppins,_sans-serif] mb-4" data-id="element-1349">
                Our Proprietary "Power Trio"
              </h3>
              <p className="text-[#B0B0B0] text-[15px] leading-[1.7] font-body mb-6" data-id="element-1350">
                Optimize your Halo Skin Resurfacing Laser treatment with Be
                CLINICAL's exclusive Power Trio blend. This proprietary mix
                includes stem cells, brightening agents, and peptides, all
                working together for glowing, beautiful results.
              </p>
              <ul className="space-y-4" data-id="element-1351">
                <li className="flex items-start gap-3" data-id="element-1352">
                  <CheckIcon size={18} className="text-[#FF1493] flex-shrink-0 mt-1" data-id="element-1353" />
                  <span className="text-[#B0B0B0] text-sm leading-[1.6] font-body" data-id="element-1354">
                    <strong className="text-white" data-id="element-1355">Stem Cells</strong> –
                    Powerful growth factors that stimulate cells to behave
                    younger.
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-1356">
                  <CheckIcon size={18} className="text-[#FF1493] flex-shrink-0 mt-1" data-id="element-1357" />
                  <span className="text-[#B0B0B0] text-sm leading-[1.6] font-body" data-id="element-1358">
                    <strong className="text-white" data-id="element-1359">Brightening Agents</strong> –
                    Glutathione and tranexamic acid for a luminous complexion.
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-1360">
                  <CheckIcon size={18} className="text-[#FF1493] flex-shrink-0 mt-1" data-id="element-1361" />
                  <span className="text-[#B0B0B0] text-sm leading-[1.6] font-body" data-id="element-1362">
                    <strong className="text-white" data-id="element-1363">Peptides</strong> – Advanced
                    formula to improve skin cell function.
                  </span>
                </li>
              </ul>
            </div>
          </AnimateOnScroll>
        </div>
      </div>
    </section>;
}